import { render, staticRenderFns } from "./SubmitalSummary.vue?vue&type=template&id=06f28320&"
import script from "./SubmitalSummary.vue?vue&type=script&lang=js&"
export * from "./SubmitalSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports